import { styled } from "@vitality-ds/system";
import BaseSidebarCloseButtonStyles from "./styles/BaseSidebarCloseButton.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseSidebarCloseButton = styled("div", BaseSidebarCloseButtonStyles);